import apiAdmin from "../utils/apiUser";

export const loginAdmin = async (usuario, password) => {
  try {
    const res = await apiAdmin.post("/api/acceso/login", { usuario, password });

    if (res.data?.token) {
      localStorage.setItem("usuario_token", res.data.token);
      localStorage.setItem("usuario", JSON.stringify(res.data.usuario));
      localStorage.setItem("usuario_id", String(res.data.usuario_id || res.data.usuario?.id || ""));
      localStorage.setItem("permisos", JSON.stringify(res.data.permisos || []));
    }

    return { ok: true, data: res.data };
  } catch (error) {
    // El interceptor de apiUser ya desenvuelve la respuesta: reemplaza el
    // error de axios por un Error con .status y .data, y NO deja .response.
    // Aca se leia error.response.data.message, que era undefined siempre,
    // asi que cualquier respuesta del backend (clave mala incluida) salia
    // como "Error al conectar con el servidor".
    //
    // status 0 es el unico caso en que de verdad no hubo respuesta:
    // servidor caido, sin red o CORS.
    const sinRespuesta = !error?.status;

    return {
      ok: false,
      data: {
        message: sinRespuesta
          ? "Could not reach the server. Please try again."
          : error?.data?.message ||
            error?.message ||
            "Invalid username or password",
      },
    };
  }
};
